/* baoks CRO v3.3 – Home interactions. No dependencies. */
(() => {
  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());

  ready(() => {
    // Reveal: adds .is-in once an element scrolls into view (marker, pops, strike, path).
    const reveal = document.querySelectorAll('[data-bk-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.25 });
      reveal.forEach((el) => io.observe(el));
    } else {
      reveal.forEach((el) => el.classList.add('is-in'));
    }

    // Video with sound: the loop runs muted; the play button switches the sound on and restarts.
    document.querySelectorAll('[data-bk-sound-toggle]').forEach((btn) => {
      const box = btn.closest('[data-bk-media]');
      const video = box && box.querySelector('video');
      if (!video) { btn.hidden = true; return; }
      // 1. Tipp: Ton an und von vorn. Danach pausiert und startet ein Tipp (Button oder Video).
      const toggle = () => {
        if (video.muted) {
          video.muted = false;
          video.currentTime = 0;
          video.play();
        } else if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      };
      const sync = () => {
        const live = !video.muted && !video.paused;
        btn.hidden = live;
        btn.classList.toggle('is-playing', live);
        btn.setAttribute('aria-label', live ? 'Pause' : (btn.dataset.labelOn || 'Ton an'));
      };
      btn.addEventListener('click', toggle);
      video.addEventListener('click', () => { if (!video.muted) toggle(); });
      ['play', 'pause', 'volumechange'].forEach((ev) => video.addEventListener(ev, sync));
    });

    // Plain video cards (experts, reels): tap poster to play with controls.
    document.querySelectorAll('[data-bk-play-video]').forEach((btn) => {
      const video = btn.closest('[data-bk-media]')?.querySelector('video');
      if (!video) { btn.hidden = true; return; }
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (video.hasAttribute('loading')) { video.removeAttribute('loading'); video.preload = 'auto'; video.load(); }
        video.dataset.started = '1';
        video.muted = false;
        video.play();
      });
      // Tipp aufs Video pausiert bzw. spielt weiter; pausiert ist der Play-Button wieder da.
      video.addEventListener('click', (e) => {
        if (!video.dataset.started) return;
        e.preventDefault();
        if (video.paused) video.play(); else video.pause();
      });
      video.addEventListener('play', () => { btn.hidden = true; });
      video.addEventListener('pause', () => { btn.hidden = false; });
    });

    // Video-Karten: Klick öffnet das Video groß mit Ton (Quelle im <template data-bk-vsrc>).
    const openVideo = (trigger) => {
      const tpl = trigger.querySelector('template[data-bk-vsrc]') || trigger.closest('.bk-q__bubble, .bk-mini-expert')?.querySelector('template[data-bk-vsrc]');
      if (!tpl) return false;
      let modal = document.querySelector('[data-bk-vmodal]');
      if (!modal) {
        modal = document.createElement('dialog');
        modal.className = 'bk bk-vmodal';
        modal.setAttribute('data-bk-vmodal', '');
        modal.innerHTML = '<button type="button" class="bk-vmodal__close" aria-label="Schließen">×</button><div class="bk-vmodal__body"></div>';
        document.body.appendChild(modal);
        const close = () => { modal.querySelector('video')?.pause(); modal.close(); };
        modal.querySelector('.bk-vmodal__close').addEventListener('click', close);
        modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
        modal.addEventListener('close', () => { modal.querySelector('.bk-vmodal__body').innerHTML = ''; });
      }
      const body = modal.querySelector('.bk-vmodal__body');
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      modal.showModal();
      const video = body.querySelector('video');
      if (video) {
        // Shopify setzt loading=lazy; im Dialog würde Chrome das Video sonst nie laden.
        video.removeAttribute('loading');
        video.preload = 'auto';
        video.load();
        video.muted = false;
        video.play().catch(() => {});
      }
      return true;
    };
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-bk-vopen]');
      if (trigger && openVideo(trigger)) e.preventDefault();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const trigger = e.target.closest('[role=button][data-bk-vopen]');
      if (trigger && openVideo(trigger)) e.preventDefault();
    });

    // Sound-Chips mit role=button auch per Tastatur abspielbar.
    document.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches?.('[data-bk-sound][role=button]')) { e.preventDefault(); e.target.click(); }
    });

    // Spar-Hinweis in der Paketauswahl: wählt direkt das größere Paket.
    document.addEventListener('click', (e) => {
      const nudge = e.target.closest('[data-bk-nudge]');
      if (!nudge) return;
      e.preventDefault();
      e.stopPropagation();
      const form = nudge.closest('[data-bk-options]');
      const radio = form?.querySelectorAll('[data-bk-opt] input[type=radio]')[parseInt(nudge.dataset.bkNudge, 10) - 1];
      if (radio && !radio.disabled) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); radio.closest('[data-bk-opt]')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
    });

    // Judge.me: Bewertungen über die öffentliche Widget-Schnittstelle laden und im eigenen Design zeigen.
    // Neue Bewertungen erscheinen automatisch; kein Schlüssel nötig (dieselben Abrufe macht das Judge.me-Widget).
    const jdgm = (() => {
      const shop = (window.Shopify && window.Shopify.shop) || 'die-welt-hinter-den-kissen.myshopify.com';
      const base = `https://api.judge.me/reviews/%s?url=${shop}&shop_domain=${shop}&platform=shopify`;
      const esc = (v) => String(v || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const sized = (u, w) => (u || '').replace(/([?&])width=\d+/, `$1width=${w}`);
      const parse = (html) => [...new DOMParser().parseFromString(html || '', 'text/html').querySelectorAll('.jdgm-rev')].map((r) => {
        const ts = r.querySelector('.jdgm-rev__timestamp')?.dataset.content;
        const prod = r.querySelector('.jdgm-rev__prod-link');
        return {
          id: r.dataset.reviewId,
          rating: parseInt(r.querySelector('.jdgm-rev__rating')?.dataset.score || '5', 10),
          title: r.querySelector('.jdgm-rev__title')?.textContent.trim() || '',
          body: r.querySelector('.jdgm-rev__body')?.textContent.trim() || '',
          author: r.querySelector('.jdgm-rev__author')?.textContent.trim() || '',
          verified: r.dataset.verifiedBuyer === 'true',
          date: ts ? new Date(ts).toLocaleDateString('de-DE') : '',
          product: prod ? { title: prod.textContent.trim(), url: prod.getAttribute('href') } : null,
          pics: [...r.querySelectorAll('.jdgm-rev__pic-link')].map((p) => p.dataset.mfpSrc || p.getAttribute('href')).filter(Boolean),
        };
      });
      const fetchPage = async ({ id, page = 1, per = 10, sort = '' }) => {
        const url = (id ? base.replace('%s', 'reviews_for_widget') + `&product_id=${id}` : base.replace('%s', 'all_reviews_js_based'))
          + `&page=${page}&per_page=${per}${sort ? `&sort_by=${sort}` : ''}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`Judge.me ${res.status}`);
        const data = await res.json();
        return { reviews: parse(data.html), total: data.number_of_reviews || data.number_of_product_reviews || 0 };
      };
      const stars = (n) => `<span class="bk-stars" aria-label="${n} von 5 Sternen">${[1, 2, 3, 4, 5].map((i) => `<span class="bk-stars__s${i > n ? ' is-off' : ''}">★</span>`).join('')}</span>`;
      const short = (t) => (t || '').split(':')[0].replace('Abenteuerband', 'Band').trim();
      const card = (r) => `<article class="bk-revcard"><div class="bk-revcard__top">${stars(r.rating)}${r.date ? `<small>${esc(r.date)}</small>` : ''}</div>`
        + `${r.title && r.title !== r.body ? `<b>${esc(r.title)}</b>` : ''}<p>${esc(r.body)}</p>`
        + `${r.pics.length ? `<div class="bk-revcard__pics">${r.pics.slice(0, 4).map((u) => `<button type="button" data-bk-revpic="${esc(sized(u, 1400))}"><img src="${esc(sized(u, 240))}" alt="Kundenfoto" loading="lazy"></button>`).join('')}</div>` : ''}`
        + `<small class="bk-revcard__by">${esc(r.author)}${r.verified ? ' · verifizierter Kauf' : ''}${r.product ? ` · ${esc(short(r.product.title))}` : ''}</small></article>`;
      return { fetchPage, card, stars, esc, sized, short };
    })();

    // Bewertungs-Fenster: Tabs „Alle“ + je Band, lädt beim Scrollen weitere Seiten. Öffnet über [data-bk-reviews].
    const getRevSheet = () => {
      let sheet = document.querySelector('[data-bk-revsheet]');
      if (sheet) return sheet;
      sheet = document.createElement('dialog');
      sheet.className = 'bk bk-revsheet';
      sheet.setAttribute('data-bk-revsheet', '');
      sheet.setAttribute('aria-label', 'Bewertungen');
      sheet.innerHTML = '<div class="bk-revsheet__bar"><b>Bewertungen</b><button type="button" class="bk-flip__close" data-bk-revsheet-close aria-label="Schließen">×</button></div>'
        + '<div class="bk-revsheet__tabs" role="tablist" data-bk-revsheet-tabs></div>'
        + '<div class="bk-revsheet__body" data-bk-revsheet-body><p class="bk-revsheet__note">Alle Bewertungen ungefiltert aus Judge.me, neueste zuerst.</p><div class="bk-revsheet__list" data-bk-revsheet-list></div><button type="button" class="bk-revsheet__more" data-bk-revsheet-more>Weitere Bewertungen laden</button></div>';
      document.body.appendChild(sheet);
      const tabsEl = sheet.querySelector('[data-bk-revsheet-tabs]');
      const list = sheet.querySelector('[data-bk-revsheet-list]');
      const more = sheet.querySelector('[data-bk-revsheet-more]');
      const body = sheet.querySelector('[data-bk-revsheet-body]');
      let tabs = [];
      let cur = null;
      const load = async () => {
        if (!cur || cur.loading || cur.done) return;
        cur.loading = true;
        more.textContent = 'Lädt …';
        const tab = cur;
        try {
          const { reviews, total } = await jdgm.fetchPage({ id: tab.id, page: tab.page + 1, per: 10 });
          tab.page += 1;
          tab.total = total || tab.total;
          tab.items.push(...reviews);
          tab.done = reviews.length < 10 || (tab.total && tab.items.length >= tab.total);
          if (tab === cur) render();
          paintTabs();
        } catch (e) {
          more.textContent = 'Konnte nicht laden – nochmal versuchen';
        }
        tab.loading = false;
        if (tab === cur && !tab.done) more.textContent = 'Weitere Bewertungen laden';
      };
      const render = () => {
        list.innerHTML = cur.items.map(jdgm.card).join('');
        more.hidden = cur.done;
      };
      const paintTabs = () => {
        tabsEl.innerHTML = tabs.map((t, i) => `<button type="button" role="tab" class="bk-revsheet__tab${t === cur ? ' is-active' : ''}" data-i="${i}">${jdgm.esc(t.label)}${t.total || t.count ? ` <small>(${t.total || t.count})</small>` : ''}</button>`).join('');
      };
      const select = (t) => {
        cur = t;
        paintTabs();
        render();
        body.scrollTo({ top: 0 });
        if (!t.page) load();
      };
      tabsEl.addEventListener('click', (e) => { const b = e.target.closest('[data-i]'); if (b) select(tabs[+b.dataset.i]); });
      more.addEventListener('click', load);
      body.addEventListener('scroll', () => { if (body.scrollTop + body.clientHeight > body.scrollHeight - 400) load(); });
      list.addEventListener('click', (e) => {
        const pic = e.target.closest('[data-bk-revpic]');
        if (pic) window.open(pic.dataset.bkRevpic, '_blank', 'noopener');
      });
      sheet.querySelector('[data-bk-revsheet-close]').addEventListener('click', () => sheet.close());
      sheet.addEventListener('click', (e) => { if (e.target === sheet) sheet.close(); });
      sheet.bkOpen = (cfg) => {
        const key = JSON.stringify(cfg.map((c) => c.id));
        if (sheet.dataset.key !== key) {
          sheet.dataset.key = key;
          tabs = cfg.map((c) => ({ ...c, page: 0, items: [], done: false, loading: false, total: 0 }));
        }
        sheet.showModal();
        select(tabs.find((t) => t.start) || tabs[0]);
      };
      return sheet;
    };
    const defaultTabs = [{ label: 'Alle', id: '' }];
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-bk-reviews]');
      if (!trigger) return;
      e.preventDefault();
      let cfg = defaultTabs;
      try { cfg = JSON.parse(trigger.dataset.bkReviews) || defaultTabs; } catch (err) { /* Standard-Tabs */ }
      getRevSheet().bkOpen(cfg);
    });

    // Foto-Mosaik: neueste Judge.me-Bewertungen mit Foto und mind. X Sternen; ohne Antwort bleiben die festen Fotos stehen.
    document.querySelectorAll('[data-bk-jdgm-mosaic]').forEach(async (mosaic) => {
      const count = parseInt(mosaic.dataset.count || '4', 10);
      const min = parseInt(mosaic.dataset.min || '4', 10);
      const picks = [];
      try {
        for (let page = 1; page <= 3 && picks.length < count; page += 1) {
          const { reviews } = await jdgm.fetchPage({ page, per: 20, sort: 'pictures_first' });
          reviews.filter((r) => r.pics.length && r.rating >= min && r.body).forEach((r) => { if (picks.length < count) picks.push(r); });
          if (reviews.length < 20) break;
        }
      } catch (e) { return; }
      if (picks.length < 2) return;
      const half = Math.ceil(picks.length / 2);
      const tile = (r, i, tall) => `<div class="bk-photo-card"><figure class="bk-photo${tall ? ' bk-photo--tall' : ''}"><img class="bk-cover" src="${jdgm.esc(jdgm.sized(r.pics[0], 700))}" alt="Kundenfoto von ${jdgm.esc(r.author)}" loading="lazy"><span class="bk-chip"><b>★</b>Kundenfoto</span></figure>`
        + `<p class="bk-photo__rev">${jdgm.stars(r.rating)}<span>„${jdgm.esc(r.body)}“</span><small>${jdgm.esc(r.author)}${r.product ? ` · ${jdgm.esc(jdgm.short(r.product.title))}` : ''}</small></p></div>`;
      const cols = mosaic.querySelectorAll('.bk-mosaic__col');
      if (cols.length !== 2) return;
      cols[0].innerHTML = picks.slice(0, half).map((r, i) => tile(r, i, i % 2 === 0)).join('');
      cols[1].innerHTML = picks.slice(half).map((r, i) => tile(r, i, i % 2 === 1)).join('');
      mosaic.classList.add('is-live');
    });

    // Empfehlung „Erzieher:innen“ in der Kaufbox: öffnet direkt das erste Pädagogen-Video statt zu springen.
    document.addEventListener('click', (e) => {
      const reco = e.target.closest('[data-bk-reco]');
      if (!reco) return;
      const video = document.querySelector('.bk-mini-expert[data-bk-vopen]');
      if (!video) return;
      e.preventDefault();
      video.click();
    });

    // Blick ins Buch: Doppelseiten groß, erst reingezoomt, dann umblättern.
    // Wird von den Weg-Karten (bk-story) und der Katalog-Schnellansicht genutzt.
    const getFlip = () => {
      let flip = document.querySelector('[data-bk-flip-dialog]');
      if (!flip) {
        flip = document.createElement('dialog');
        flip.className = 'bk bk-flip';
        flip.setAttribute('data-bk-flip-dialog', '');
        flip.innerHTML = '<div class="bk-flip__bar"><b data-bk-flip-title></b><span data-bk-flip-page></span><button type="button" class="bk-flip__close" data-bk-flip-close aria-label="Schließen">×</button></div>'
          + '<div class="bk-flip__stage is-zoomed" data-bk-flip-stage><img data-bk-flip-img src="" alt=""></div>'
          + '<div class="bk-flip__nav"><button type="button" class="bk-flip__arrow bk-flip__arrow--prev" data-bk-flip-step="-1" aria-label="Zurückblättern"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M13 6l6 6-6 6"/></svg></button>'
          + '<button type="button" class="bk-flip__zoom" data-bk-flip-zoom data-in="Reinzoomen zum Lesen" data-out="Ganze Doppelseite">Ganze Doppelseite</button>'
          + '<button type="button" class="bk-flip__arrow" data-bk-flip-step="1" aria-label="Weiterblättern"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M13 6l6 6-6 6"/></svg></button></div>'
          + '<p class="bk-flip__hint">Pfeile oder Wischen zum Umblättern</p>';
        document.body.appendChild(flip);
      }
      if (flip.dataset.ready) return flip;
      flip.dataset.ready = '1';
      const stage = flip.querySelector('[data-bk-flip-stage]');
      const img = flip.querySelector('[data-bk-flip-img]');
      const pageEl = flip.querySelector('[data-bk-flip-page]');
      const titleEl = flip.querySelector('[data-bk-flip-title]');
      const zoomBtn = flip.querySelector('[data-bk-flip-zoom]');
      const nav = flip.querySelector('.bk-flip__nav');
      let cta = flip.querySelector('[data-bk-flip-cta]');
      if (!cta) {
        cta = document.createElement('a');
        cta.className = 'bk-flip__cta';
        cta.setAttribute('data-bk-flip-cta', '');
        cta.hidden = true;
        nav.after(cta);
      }
      const state = { list: [], idx: 0 };
      const setZoom = (on) => {
        stage.classList.toggle('is-zoomed', on);
        zoomBtn.textContent = on ? zoomBtn.dataset.out : zoomBtn.dataset.in;
        stage.scrollTo({ left: 0, top: 0 });
      };
      const render = () => {
        const item = state.list[state.idx];
        img.src = item.src;
        img.alt = `${titleEl.textContent} · ${item.label || ''}`;
        pageEl.textContent = `${item.label ? item.label + ' · ' : ''}${state.idx + 1}/${state.list.length}`;
        flip.querySelectorAll('[data-bk-flip-step]').forEach((b) => {
          const n = state.idx + parseInt(b.dataset.bkFlipStep, 10);
          b.disabled = n < 0 || n >= state.list.length;
        });
        stage.scrollTo({ left: 0, top: 0 });
        if (state.list[state.idx + 1]) new Image().src = state.list[state.idx + 1].src;
      };
      const go = (step) => {
        const n = state.idx + step;
        if (n < 0 || n >= state.list.length) return;
        state.idx = n;
        render();
      };
      flip.bkOpen = (list, title, opts = {}) => {
        state.list = list;
        state.idx = 0;
        titleEl.textContent = title || '';
        cta.hidden = !opts.url;
        if (opts.url) { cta.href = opts.url; cta.textContent = opts.cta || 'Zum Buch'; }
        flip.showModal();
        setZoom(opts.zoom !== false);
        render();
      };
      flip.querySelector('[data-bk-flip-close]').addEventListener('click', () => flip.close());
      flip.addEventListener('click', (e) => { if (e.target === flip) flip.close(); });
      flip.querySelectorAll('[data-bk-flip-step]').forEach((b) => b.addEventListener('click', () => go(parseInt(b.dataset.bkFlipStep, 10))));
      zoomBtn.addEventListener('click', () => setZoom(!stage.classList.contains('is-zoomed')));
      img.addEventListener('dblclick', () => setZoom(!stage.classList.contains('is-zoomed')));
      flip.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') go(1);
        if (e.key === 'ArrowLeft') go(-1);
      });
      let x0 = null;
      stage.addEventListener('touchstart', (e) => { x0 = stage.classList.contains('is-zoomed') ? null : e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        x0 = null;
      });
      return flip;
    };
    const parseList = (raw) => { try { return JSON.parse(raw) || []; } catch (e) { return []; } };
    document.querySelectorAll('[data-bk-flip]').forEach((card) => {
      card.addEventListener('click', () => {
        const list = parseList(card.dataset.bkFlip);
        if (list.length) getFlip().bkOpen(list, card.dataset.bkFlipTitle);
      });
    });
    // Katalog: „Blick ins Buch“ öffnet die Schnellansicht, der Rest der Karte führt zum Produkt.
    document.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-bk-quick]');
      if (!chip) return;
      e.preventDefault();
      e.stopPropagation();
      const list = parseList(chip.dataset.bkQuick);
      if (list.length) getFlip().bkOpen(list, chip.dataset.bkQuickTitle, { url: chip.dataset.bkQuickUrl, cta: chip.dataset.bkQuickCta, zoom: chip.dataset.bkQuickZoom === 'true' });
    }, true);
    document.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches?.('[data-bk-quick]')) { e.preventDefault(); e.target.click(); }
    });

    // Page zoom: tap a page card to see the page large.
    const dialog = document.querySelector('[data-bk-zoom-dialog]');
    if (dialog) {
      const img = dialog.querySelector('img');
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
      document.querySelectorAll('[data-bk-zoom]').forEach((card) => {
        card.addEventListener('click', () => {
          const src = card.querySelector('img')?.currentSrc || card.querySelector('img')?.src;
          if (!src) return;
          img.src = src;
          img.alt = card.dataset.bkZoom || '';
          dialog.showModal();
        });
      });
    }

    // Step tabs (mobile): jump to the step and highlight the visible one.
    document.querySelectorAll('[data-bk-tabs]').forEach((tabs) => {
      const buttons = [...tabs.querySelectorAll('button[data-target]')];
      const targets = buttons.map((b) => document.getElementById(b.dataset.target)).filter(Boolean);
      buttons.forEach((b) => b.addEventListener('click', () => {
        document.getElementById(b.dataset.target)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }));
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.target === e.target.id));
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      targets.forEach((t) => io.observe(t));
    });

    // Sound chips: play the clip if a file is set, always trigger a pop.
    let current;
    document.querySelectorAll('[data-bk-sound]').forEach((chip) => {
      chip.addEventListener('click', () => {
        const section = chip.closest('.bk-app');
        const pop = section?.querySelector('.bk-pop--' + (chip.dataset.pop || '1'));
        if (pop) {
          pop.classList.remove('is-burst');
          void pop.offsetWidth;
          pop.classList.add('is-burst');
        }
        const src = chip.dataset.bkSound;
        if (!src) return;
        if (current && current.chip === chip && !current.audio.paused) {
          current.audio.pause();
          chip.classList.remove('is-playing');
          return;
        }
        if (current) { current.audio.pause(); current.chip.classList.remove('is-playing'); }
        const audio = new Audio(src);
        current = { audio, chip };
        chip.classList.add('is-playing');
        audio.addEventListener('ended', () => chip.classList.remove('is-playing'));
        audio.play().catch(() => chip.classList.remove('is-playing'));
      });
    });
  });
})();

/* Leiste, Header-Menü, Sticky-Offset */
(() => {
  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());
  ready(() => {
    document.querySelectorAll('[data-bk-slider]').forEach((bar) => {
      // Abgelaufene Deals entfernen (die Seite kann aus dem Cache kommen).
      bar.querySelectorAll('[data-bk-deal]').forEach((d) => {
        const end = d.dataset.ends ? Date.parse(d.dataset.ends.replace(' ', 'T') + (/[zZ]|[+-]\d\d:?\d\d$/.test(d.dataset.ends) ? '' : '+01:00')) : NaN;
        if (!Number.isNaN(end) && Date.now() > end) d.remove();
      });
      const slides = [...bar.querySelectorAll('.bk-bar__slide')];
      const dotsWrap = bar.querySelector('.bk-bar__dots');
      if (dotsWrap) dotsWrap.innerHTML = slides.map(() => '<i></i>').join('');
      const dots = [...bar.querySelectorAll('.bk-bar__dots i')];
      let i = 0;
      const show = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        bar.classList.toggle('is-deal', !!slides[i]?.hasAttribute('data-bk-deal'));
      };
      show(0);
      bar.querySelectorAll('[data-bk-copy]').forEach((btn) => btn.addEventListener('click', () => {
        const code = btn.dataset.bkCopy;
        navigator.clipboard?.writeText(code).then(() => {
          btn.textContent = 'Kopiert ✓';
          setTimeout(() => { btn.textContent = code; }, 1600);
        }).catch(() => {});
      }));
      if (slides.length < 2) return;
      const ms = (parseInt(bar.dataset.interval, 10) || 5) * 1000;
      let timer = setInterval(() => show(i + 1), ms);
      bar.querySelectorAll('[data-bk-slide]').forEach((b) => b.addEventListener('click', () => {
        clearInterval(timer);
        show(i + parseInt(b.dataset.bkSlide, 10));
        timer = setInterval(() => show(i + 1), ms);
      }));
    });

    document.querySelectorAll('[data-bk-header]').forEach((header) => {
      const menu = header.querySelector('[data-bk-menu]');
      header.querySelector('[data-bk-menu-open]')?.addEventListener('click', () => menu?.showModal());
      menu?.querySelectorAll('[data-bk-menu-close]').forEach((el) => el.addEventListener('click', () => menu.close()));
      menu?.addEventListener('click', (e) => { if (e.target === menu) menu.close(); });
    });

    const setOffsets = () => {
      const bar = document.querySelector('#header-group .bk-bar');
      const header = document.querySelector('#header-group .bk-header');
      document.documentElement.style.setProperty('--bk-bar-h', (bar ? bar.offsetHeight : 0) + 'px');
      document.documentElement.style.setProperty('--bk-header-h', (header ? header.offsetHeight : 0) + 'px');
    };
    setOffsets();
    window.addEventListener('resize', setOffsets);
  });
})();

/* PDP: Galerie, Paketauswahl, Sticky-Kaufleiste */
(() => {
  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());
  ready(() => {
    document.querySelectorAll('[data-bk-gallery]').forEach((gal) => {
      const track = gal.querySelector('[data-bk-gallery-track]');
      const root = gal.closest('.bk-pdp');
      const dotsWrap = root && root.querySelector('.bk-gallery__dots');
      const thumbsWrap = root && root.querySelector('.bk-gallery__thumbs');
      const badge = gal.querySelector('.bk-gallery__badge');
      const original = { track: track.innerHTML, dots: dotsWrap ? dotsWrap.innerHTML : '', thumbs: thumbsWrap ? thumbsWrap.innerHTML : '' };
      const setActive = (i) => {
        if (dotsWrap) [...dotsWrap.children].forEach((d, k) => d.classList.toggle('is-active', k === i));
        if (thumbsWrap) [...thumbsWrap.querySelectorAll('[data-bk-thumb]')].forEach((t, k) => t.classList.toggle('is-active', k === i));
      };
      track.addEventListener('scroll', () => {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
      }, { passive: true });
      if (thumbsWrap) thumbsWrap.addEventListener('click', (e) => {
        const t = e.target.closest('[data-bk-thumb]');
        if (!t) return;
        const i = parseInt(t.dataset.bkThumb, 10);
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
      /* Optionswechsel: Bilder des gewählten Produkts zeigen, eigene Option stellt die Seitenbilder wieder her */
      if (root) root.addEventListener('bk:option', (e) => {
        const data = root.querySelector(`[data-bk-gallery-set="${e.detail.variant}"]`);
        if (!data) {
          track.innerHTML = original.track;
          if (dotsWrap) dotsWrap.innerHTML = original.dots;
          if (thumbsWrap) thumbsWrap.innerHTML = original.thumbs;
          if (badge) badge.hidden = false;
        } else {
          const imgs = JSON.parse(data.textContent);
          const esc = (v) => String(v).replace(/"/g, '&quot;');
          track.innerHTML = imgs.map((m) => `<figure class="bk-gallery__slide"><img class="bk-gallery__img" src="${esc(m.src)}" srcset="${esc(m.srcset)}" sizes="(min-width: 990px) 560px, 100vw" alt="${esc(m.alt)}"></figure>`).join('');
          if (dotsWrap) dotsWrap.innerHTML = imgs.map((m, i) => `<i${i === 0 ? ' class="is-active"' : ''}></i>`).join('');
          if (thumbsWrap) thumbsWrap.innerHTML = imgs.map((m, i) => `<button type="button" data-bk-thumb="${i}" class="${i === 0 ? 'is-active' : ''}" aria-label="Bild ${i + 1}"><img class="bk-cover" src="${esc(m.thumb)}" alt="" loading="lazy"></button>`).join('');
          if (badge) badge.hidden = true;
        }
        track.scrollTo({ left: 0 });
        setActive(0);
      });
    });

    document.querySelectorAll('[data-bk-options]').forEach((form) => {
      const section = form.closest('.bk-pdp');
      const hidden = form.querySelector('[data-bk-variant]');
      const priceEls = section.querySelectorAll('[data-bk-cta-price], [data-bk-sticky-price]');
      const titleEl = section.querySelector('[data-bk-sticky-title]');
      form.querySelectorAll('input[type=radio]').forEach((radio) => {
        radio.addEventListener('change', () => {
          form.querySelectorAll('[data-bk-opt]').forEach((o) => o.classList.toggle('is-selected', o.contains(radio)));
          hidden.value = radio.value;
          section.querySelectorAll('[data-bk-express] input[name=id]').forEach((i) => { i.value = radio.value; });
          section.dispatchEvent(new CustomEvent('bk:option', { detail: { variant: radio.value } }));
          const count = radio.closest('[data-bk-opt]').querySelector('[data-bk-count]');
          if (count && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            const target = parseInt(count.dataset.bkCount, 10) / 100;
            const prefix = count.textContent.trim().startsWith('€');
            const num = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            const fmt = { format: (v) => (prefix ? '€' + num.format(v) : num.format(v) + ' €') };
            const start = performance.now() + 200;
            const tick = (now) => {
              const t = Math.min(Math.max((now - start) / 600, 0), 1);
              count.textContent = fmt.format(target * (1 - Math.pow(1 - t, 3)));
              if (t < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
          priceEls.forEach((el) => { el.textContent = radio.dataset.price; });
          section.querySelectorAll('[data-bk-vat]').forEach((el) => {
            const cents = parseInt(radio.dataset.cents || '0', 10);
            el.textContent = cents >= 4500 ? el.dataset.free : el.dataset.paid;
          });
          if (titleEl) titleEl.textContent = radio.dataset.title;
        });
      });
    });

    const sticky = document.querySelector('[data-bk-sticky]');
    const cta = document.querySelector('[data-bk-cta]');
    if (sticky && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
      }).observe(cta);
    }
  });
})();

/* Bewertungs-Slider: auf Touch-Geräten beim Antippen pausieren */
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-bk-marquee]').forEach((m) => {
      m.addEventListener('touchstart', () => m.classList.add('is-paused'), { passive: true });
      m.addEventListener('touchend', () => setTimeout(() => m.classList.remove('is-paused'), 1500), { passive: true });
    });
  });
})();

/* Elternstimmen: Zähler und Punkte der ausgewählten Bewertungs-Karten */
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-bk-rcards]').forEach((wrap) => {
      const track = wrap.querySelector('[data-bk-rcards-track]');
      const now = wrap.querySelector('[data-bk-rcards-now]');
      const dots = wrap.querySelectorAll('.bk-rcards__dots i');
      const cards = track.children;
      if (!cards.length) return;
      track.addEventListener('scroll', () => {
        const step = cards[0].getBoundingClientRect().width + 12;
        const i = Math.min(cards.length - 1, Math.round(track.scrollLeft / step));
        if (now) now.textContent = i + 1;
        dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      }, { passive: true });
    });
  });
})();

/* Warenkorb-Drawer (sections/bk-cart-drawer.liquid): öffnen, Menge, Upgrade, Cross-Sell, AJAX-Add */
(() => {
  const root = () => document.querySelector('[data-bk-cart]');
  const sectionId = () => root()?.dataset.sectionId;
  const cartUrl = (path) => (window.Shopify?.routes?.root || '/') + path;

  const render = (html) => {
    const el = root();
    if (!el || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-bk-cart-body]');
    const body = el.querySelector('[data-bk-cart-body]');
    if (next && body) body.replaceWith(next);
    const count = parseInt(next?.dataset.count || '0', 10);
    document.querySelectorAll('[data-bk-cart-count]').forEach((c) => { c.textContent = count; c.hidden = count === 0; });
    rotateReview();
  };

  const refresh = () => fetch(cartUrl(`?sections=${sectionId()}`))
    .then((r) => r.json()).then((j) => render(j[sectionId()]));

  const post = (path, payload) => {
    const body = root()?.querySelector('[data-bk-cart-body]');
    body?.classList.add('is-busy');
    return fetch(cartUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...payload, sections: [sectionId()], sections_url: location.pathname }),
    }).then((r) => r.json()).then((j) => {
      if (j.sections && j.sections[sectionId()]) render(j.sections[sectionId()]);
      else return refresh();
      return j;
    }).finally(() => root()?.querySelector('[data-bk-cart-body]')?.classList.remove('is-busy'));
  };

  function rotateReview() {
    const quotes = root()?.querySelectorAll('.bk-cartd__quote');
    if (!quotes || quotes.length < 2) return;
    const pick = Math.floor(Math.random() * quotes.length);
    quotes.forEach((q, i) => { q.hidden = i !== pick; });
  }

  const open = () => {
    const el = root();
    if (!el) return false;
    el.classList.add('is-open');
    document.documentElement.classList.add('bk-cart-lock');
    el.querySelector('.bk-cartd__panel')?.focus();
    return true;
  };
  const close = () => {
    root()?.classList.remove('is-open');
    document.documentElement.classList.remove('bk-cart-lock');
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-bk-cart-open]');
    if (opener && root()) { e.preventDefault(); rotateReview(); open(); return; }
    if (e.target.closest('[data-bk-cart-close]')) { close(); return; }
    const qty = e.target.closest('[data-bk-qty]');
    if (qty) { post('cart/change.js', { id: qty.dataset.key, quantity: parseInt(qty.dataset.qty, 10) }); return; }
    const up = e.target.closest('[data-bk-upgrade]');
    if (up) {
      const updates = {};
      (up.dataset.remove || '').split(',').filter(Boolean).forEach((k) => { updates[k] = 0; });
      post('cart/update.js', { updates })
        .then(() => post('cart/add.js', { items: [{ id: parseInt(up.dataset.add, 10), quantity: 1 }] }));
      return;
    }
    const add = e.target.closest('[data-bk-add]');
    if (add) post('cart/add.js', { items: [{ id: parseInt(add.dataset.bkAdd, 10), quantity: 1 }] });
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  /* Drawer direkt an <body> hängen: Container mit transform/contain würden position: fixed verschieben */
  const portal = () => { const el = root(); if (el && el.parentElement !== document.body) document.body.appendChild(el); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', portal); else portal();

  /* „In den Warenkorb“-Formulare der bk-Sektionen per AJAX, danach Drawer öffnen */
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!root() || !(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add') || form.closest('[data-bk-cart]') || !form.closest('.bk')) return;
    e.preventDefault();
    const fd = new FormData(form);
    fd.append('sections', sectionId());
    fd.append('sections_url', location.pathname);
    fetch(cartUrl('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok) { form.submit(); return; }
        if (j.sections && j.sections[sectionId()]) render(j.sections[sectionId()]);
        open();
      })
      .catch(() => form.submit());
  }, true);

  /* Warenkorb-Änderungen aus dem Basis-Theme (alte Produktseiten) */
  document.addEventListener('cart:update', () => { refresh().then(open); });
})();

/* Kaufbox: Band-Umschalter in der Einzelband-Option (Band 1–3), wechselt Variante, Texte, Cover und Galerie */
(() => {
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-bk-switch]');
    if (!chip) return;
    e.preventDefault();
    const card = chip.closest('[data-bk-opt]');
    const radio = card?.querySelector('input[type=radio]');
    if (!radio) return;
    card.querySelectorAll('[data-bk-switch]').forEach((c) => c.classList.toggle('is-active', c === chip));
    const label = chip.dataset.label || '';
    card.querySelectorAll('[data-bk-band]').forEach((el) => { el.textContent = label; });
    const cover = card.querySelector('[data-bk-band-cover] img');
    if (cover && chip.dataset.cover) { cover.src = chip.dataset.cover; cover.removeAttribute('srcset'); }
    radio.value = chip.dataset.variant;
    radio.dataset.price = chip.dataset.price;
    if (radio.dataset.titleTpl) radio.dataset.title = radio.dataset.titleTpl.replace('[band]', label);
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
